module.exports = __webpack_public_path__ + "img/3.52c00895.jpg";